import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

import "../../../styles/components/utils/components/InfoModal.scss";
import info from "../../../styles/images/info.svg";

class InfoModal extends Component {
  render() {
    return (
      <Modal id="infoModal" show={this.props.show} onHide={this.props.onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <img src={info} alt="" />
            <span>{this.props.title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.children}</Modal.Body>
      </Modal>
    );
  }
}

export default InfoModal;
